module.exports = __webpack_public_path__ + "img/battleBg.ce3bcb3f.png";